/* ============================================================
 * Karl Kaplan – Cart quantity-discount auto-apply (P1·11)
 * <kkb-cart-discount> lives inside the cart drawer. On every
 * drawer render it applies the matching quantity discount code
 * (KKSET2 at >=2 items, KKSET3 at >=3) so "15% ab 3 Teile" holds
 * for the whole cart, not only for widget-added items.
 * Guards: skips if the right code is already applied, and never
 * overrides a customer's own (non-KK) discount code.
 * ============================================================ */
(function () {
  if (window.customElements.get('kkb-cart-discount')) return;
  var OURS = ['KKSET2', 'KKSET3'];

  class KkbCartDiscount extends HTMLElement {
    connectedCallback() { this.sync(); }

    async sync() {
      var t2 = parseInt(this.getAttribute('data-t2') || '2', 10);
      var t3 = parseInt(this.getAttribute('data-t3') || '3', 10);
      var t2code = (this.getAttribute('data-t2-code') || '').trim();
      var t3code = (this.getAttribute('data-t3-code') || '').trim();
      var count = parseInt(this.getAttribute('data-count') || '0', 10);

      var needed = count >= t3 ? t3code : (count >= t2 ? t2code : '');
      if (!needed) return;

      var cart;
      try {
        cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      } catch (e) { return; }

      var applied = (cart.cart_level_discount_applications || []).map(function (d) {
        return (d.title || '').toUpperCase();
      });

      // Already the correct code → nothing to do.
      if (applied.indexOf(needed.toUpperCase()) !== -1) return;
      // A customer's own (non-KK) code is active → don't override it.
      var hasForeign = applied.some(function (t) { return t && OURS.indexOf(t) === -1; });
      if (hasForeign) return;

      try {
        await fetch('/discount/' + encodeURIComponent(needed), {
          method: 'GET', redirect: 'follow', credentials: 'same-origin'
        });
      } catch (e) { return; }

      // Re-render the drawer once so the reduced price shows immediately.
      var drawer = this.closest('cart-drawer')
        || document.querySelector('cart-notification')
        || document.querySelector('cart-drawer');
      if (drawer && drawer.getSectionsToRender && drawer.renderContents) {
        try {
          var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
          var sections = await fetch('/?sections=' + encodeURIComponent(ids.join(','))).then(function (r) { return r.json(); });
          drawer.renderContents({ sections: sections });
        } catch (e) { /* non-fatal: code is applied, shows on next cart update */ }
      }
    }
  }

  window.customElements.define('kkb-cart-discount', KkbCartDiscount);
})();
